/* eslint-disable no-undef */
import './scss/checkout.scss';
import '../_shared/form_builder_2/scss/index.scss';
import { escape as escapeHTML } from "html-escaper";
import dateFormat from 'dateformat';
import Form from '../form_builder_2/form';
import { scrollToElement } from '../utils/dom';
import SessionTabs from '../utils/session-tabs';
import StringUtils from '../utils/string-utils';
import CurrencyFormatter from '../utils/currency-formatter-lib';
import { getNumberWithDecimals } from '../utils/number-utils';
import DateHelper from '../utils/date-helper';
import Tooltip from '../utils/tooltip';
import DownloadBase64 from '../utils/download-base64';
import AnalyticsHelper from '../utils/analytics-helper';
import { getBanner, addTooltips } from "../utils/promotions-helper";
import { pushEmailAnalytics } from '../utils/ecomm-email-analytics';
export default class CarCheckout {

    constructor(el) {
        this.el = el;
        this.confirmation = el.dataset.confirmation;
        this.cancel = el.dataset.cancel;
        this.dateLocale = el.dataset.dateLocale;
        this.dealerUrl = el.dataset.dealerUrl;
        this.myAccount2 = window.HONDA.MyAccount2;
        this.checkoutView = this.el.querySelector('.checkout-view');
        this.checkoutWrapper = el.querySelector('.checkout-form--wrapper');
        this.loadingFinanceQuote = this.el.querySelector('.order-checkout-loader-wrapper');
        this.financeQuoteCta = this.el.querySelector('.quote-download-link-container');
        this.downloadQuoteLink = this.financeQuoteCta.querySelector('.finance-cta');
        this.backToConfiguratorLink = el.querySelector('#back-to-configurator-link');
        this.confirmCta = el.querySelector('#confirm-selection');
        this.formView = el.querySelector('.checkout-form-view');
        this.summaryView = el.querySelector('.checkout-summary-view');
        this.summaryDetails = this.summaryView.querySelector('.summary-details');
        this.retailerLinkContainer = this.summaryView.querySelector('.retailer-link-wrapper');
        this.termsConditionCheckboxes = this.summaryView.querySelectorAll('.terms_condition_checkboxes .form_field_checkbox');
        this.retailerLink = this.retailerLinkContainer.querySelector('.retailer-link');
        this.depositLoader = this.summaryView.querySelector('.holding-deposit-cta .form_builder_loader');
        this.retailerLink.href = '#';
        this.currentPlacedOrder = {};
        this.hideElements([this.retailerLinkContainer]);
        this.multipleOrdersWrapper = this.el.querySelector('.error-multiple-orders');
        this.noWishlist = this.el.querySelector('.error-no-wishlist');
        this.orderCheckoutLoader = this.el.querySelector('.order--checkout-loader');
        this.carHeader = this.checkoutView.querySelector('#car-header');
        this.cardHeaderTemplate = _.template(this.checkoutView.querySelector('#car-header-template').innerHTML.replaceAll('\\', ''));
        this.estimatedDeliveryWrapper = this.el.querySelector('.estimated-delivery-wrapper');
        this.estimatedMonthWrapper = this.estimatedDeliveryWrapper.querySelector('.estimated-delivery-month');
        this.chosenDealerLabel = this.el.querySelector('.chosen-dealer-label');
        this.chooseDealerLabel = this.el.querySelector('.choose-dealer-label');
        this.changeDealerLabel = this.el.querySelector('.change-dealer-label');
        this.terms1 = this.summaryView.querySelector('[name="terms1"]');
        this.terms2 = this.summaryView.querySelector('[name="terms2"]');

        this.summaryItems = {
            orderBrief: this.summaryDetails.querySelector('#order-brief'),
            orderSelectionDetails: this.summaryDetails.querySelector('#order-selection-details'),
            orderPickupDetails: this.summaryDetails.querySelector('#order-pickup-details'),
            orderPartexDetails: this.summaryDetails.querySelector('#order-partex-details'),
            orderCostBreakdown: this.summaryDetails.querySelector('#order-cost-breakdown'),
            orderDeposits: this.summaryDetails.querySelector('#order-deposits'),
            totalPayable: this.summaryDetails.querySelector('#total-payable'),
        };

        this.summaryTemplates = {
            orderBrief: _.template(this.summaryDetails.querySelector('#order-brief-template').innerHTML.replaceAll('\\', '')),
            orderSelectionDetails: _.template(this.summaryDetails.querySelector('#order-selection-details-template').innerHTML.replaceAll('\\', '')),
            orderPickupDetails: _.template(this.summaryDetails.querySelector('#order-pickup-details-template').innerHTML.replaceAll('\\', '')),
            orderPartexDetails: _.template(this.summaryDetails.querySelector('#order-partex-details-template').innerHTML.replaceAll('\\', '')),
            orderCostBreakdown: _.template(this.summaryDetails.querySelector('#order-cost-breakdown-template').innerHTML.replaceAll('\\', '')),
            orderDeposits: _.template(this.summaryDetails.querySelector('#order-deposits-template').innerHTML.replaceAll('\\', '')),
            totalPayable: _.template(this.summaryDetails.querySelector('#total-payable-template').innerHTML.replaceAll('\\', '')),
        };

        this.currencyFormatter = new CurrencyFormatter();

        this.init();
    }

    async init() {
        if (!this.myAccount2?.isLoggedIn()) {
            this.myAccount2.showModal({ close: false, guest: false });
        }

        this.hideElements([this.summaryView]);

        await SessionTabs.share('ma2-checkout');
        this.getCheckout();

        if (!this.myAccount2?.isLoggedIn()) {
            this.myAccount2.showModal({ close: true, guest: false });
            this.myAccount2.addEventListener('close', () => {
                window.location.href = this.checkout?.temp?.configuratorUrl ?? this.cancel;
            });
        }

        if (this.checkout) {
            this.bind();
            this.setBackToConfiguratorLink();
            this.renderHeader();
        } else {
            this.showElements([this.noWishlist]);
            this.hideElements([this.checkoutView, this.orderCheckoutLoader]);
        }
        Tooltip.init();
    }

    initForm() {
        if (!this.form) {
            this.form = new Form(this.checkoutWrapper, {
                onSubmit: this.onSubmit.bind(this),
                onSuccess: this.onSuccess.bind(this),
                onError: this.onError.bind(this),
                onUpdate: this.onUpdate.bind(this),
            });
        }
    }

    async setEstimatedDate() {
        const carLeadTimesOrder = this.checkout?.temp?.leadTime;

        if (carLeadTimesOrder) {
            const estimatedDate = await window.HONDA.MyAccount2.client.getCarLeadTime(carLeadTimesOrder);
            const estimatedHandover = estimatedDate?.expectedHOD;
            const isDateAfter5Years = DateHelper.isDateAfterDaysFromToday({ date: estimatedHandover, days: 5 * 365 });

            if (estimatedHandover && !isDateAfter5Years) {
                const estimatedDeliveryMonth = DateHelper.getEstimatedMonth({ estimatedDate: estimatedHandover, locale: this.dateLocale, shouldRoundUpMonth: true });
                this.estimatedMonthWrapper.textContent = estimatedDeliveryMonth;
                this.estimatedDeliveryWrapper.classList.remove('loading');
                this.estimatedDeliveryWrapper.classList.add('loaded');
            } else {
                this.hideElements([this.estimatedDeliveryWrapper]);
            }
        } else {
            this.hideElements([this.estimatedDeliveryWrapper]);
        }
    }

    renderHeader() {
        if (this.checkout) {
            this.carHeader.innerHTML = this.cardHeaderTemplate({ checkout: this.checkout });
        }
    }

    async getCurrentOrders() {
        const orders = await window.HONDA.MyAccount2.client.getOrders();
        const allowOrder = orders.length === 0
            || orders?.every((order) => order.orderStatus === 'Interest Submitted'
                || order.orderStatus === 'Order Cancelled'
                || order.orderStatus === 'Handover Complete');

        if (!allowOrder) {
            this.showElements([this.multipleOrdersWrapper]);
        } else {
            this.showElements([this.checkoutView]);
            this.initForm();
            this.setEstimatedDate();
        }

        this.hideElements([this.orderCheckoutLoader]);
    }

    bind() {
        this.myAccount2?.addEventListener('login', () => {
            this.getCurrentOrders();
        });

        this.confirmCta.addEventListener('click', async (e) => {
            e.preventDefault();
            localStorage.setItem('ma2-checkout-terms', true);
            sessionStorage.removeItem('ma2-checkout');
            this.analyticsPush('confirm');
            this.showElements([this.depositLoader]);
            if (this.terms1.checked && this.terms2.checked) {
                this.paymentLink = await this.getPaymentLink(this.currentPlacedOrder.result);
                if (!this.paymentLink) {
                    const link = await this.getDealerLink(this.currentPlacedOrder);
                    this.retailerLink.setAttribute('href', link);
                    this.hideElements([this.confirmCta]);
                    this.termsConditionCheckboxes.forEach((element) => {
                        element.classList.add('hide');
                    });
                    this.hideElements([this.depositLoader]);
                    this.showElements([this.retailerLinkContainer]);
                } else {
                    this.hideElements([this.retailerLinkContainer]);
                    this.showElements([this.confirmCta]);
                    this.termsConditionCheckboxes.forEach((element) => {
                        element.classList.remove('hide');
                    });
                    this.hideElements([this.depositLoader]);
                }
                window.location.href = this.paymentLink;
            }
        });

        this.summaryView.addEventListener('click', (e) => {
            if (e.target.matches('#back-to-order-form-link')) {
                e.preventDefault();
                this.showElements([this.formView]);
                this.hideElements([this.summaryView]);
                this.showElements([this.confirmCta]);
                this.retailerLink.setAttribute('href', '#');
                this.hideElements([this.retailerLinkContainer]);
                scrollToElement(document.querySelector('html'));

                const clickText = e.target?.textContent?.trim() || '';
                const { modelCode } = this.checkout.temp.ids;

                // analytics push
                AnalyticsHelper.push({
                    event: 'checkout_entry',
                    eventCategory: 'checkout',
                    eventAction: 'Entry',
                    eventLabel: `cars|${modelCode}|checkout|${clickText}|internal|middle|#`,
                    actionType: 'Entry',
                    businessUnit: 'cars',
                    moduleName: 'checkout',
                    clickText: `${clickText}`,
                    clickType: 'internal',
                    destinationURL: '#',
                    modelSelected: `${modelCode}`,
                    inPageLocation: 'top',
                });
            }
        });

        this.terms1.addEventListener('change', () => this.toggleCTALink());
        this.terms2.addEventListener('change', () => this.toggleCTALink());

        this.backToConfiguratorLink.addEventListener('click', (e) => {
            e.preventDefault();
            const clickText = e.target?.textContent?.trim() || '';
            const { modelCode } = this.checkout.temp.ids;

            // analytics push
            AnalyticsHelper.push({
                event: 'configurator',
                eventCategory: 'configurator',
                eventAction: 'Entry',
                eventLabel: `cars|${modelCode}|checkout|${clickText}|internal|middle|#`,
                actionType: 'Entry',
                businessUnit: 'cars',
                moduleName: 'checkout',
                clickText: `${clickText}`,
                clickType: 'internal',
                destinationURL: '#',
                modelSelected: `${modelCode}`,
                inPageLocation: 'middle',
            });
        });

        this.toggleCTALink();
    }

    toggleCTALink() {
        if (this.terms1.checked && this.terms2.checked) {
            this.confirmCta.classList.remove('disabled');
        } else {
            this.confirmCta.classList.add('disabled');
        }
    }

    formatCurrency(val, allowZero) {
        const value = val !== null && !isNaN(val) ? +val : NaN;

        if (isNaN(value)) {
            return window?.HONDA?.CarCheckoutLabels.missingPrice ?? '';
        }

        if (!allowZero && value === 0) {
            return window?.HONDA?.CarCheckoutLabels?.asStandard ?? '';
        }
        return this.currencyFormatter.to(value);
    }

    showElements(elementList) {
        elementList.forEach((element) => {
            element.classList.remove('hide');
        });
    }

    hideElements(elementList) {
        elementList.forEach((element) => {
            element.classList.add('hide');
        });
    }

    onSubmit() {
        scrollToElement(document.querySelector('html'));
        this.showElements([this.loadingFinanceQuote]);
        this.hideElements([this.formView]);
    }

    async onSuccess(order) {
        scrollToElement(document.querySelector('html'));
        window.HONDA.MyAccount2.client.flushCache('orders');
        window.HONDA.MyAccount2.client.flushCache('personal-details');
        this.analyticsPush('submit');
        const orders = await window.HONDA.MyAccount2.client.getOrders();
        this.currentPlacedOrder = {};
        if (orders && orders.length > 0) {
            const orderIdToMatch = order.result.orderId;
            const matchedOrder = orders.find((currentOrder) => currentOrder.orderId === orderIdToMatch);
            if (matchedOrder) {
                this.currentPlacedOrder = order;
                this.removeMtoceSavedConfiguration(matchedOrder);
                this.renderSummaryView(matchedOrder);

                this.showElements([this.summaryView]);
                this.hideElements([this.loadingFinanceQuote]);
                this.hideElements([this.formView]);

                if (this.financeQuoteCta && matchedOrder.financeQuotePDFBase64) {
                    this.financeQuoteCta.classList.remove('hide');
                    this.downloadQuoteLink.addEventListener('click', (event) => {
                        event.preventDefault();
                        DownloadBase64.downloadPDF(matchedOrder.financeQuotePDFBase64, `honda-finance-quote-${matchedOrder.orderId}`);
                        const clickText = this.downloadQuoteLink?.textContent?.trim() || '';
                        const modelCode = matchedOrder?.summary?.ids?.modelCode;
                        AnalyticsHelper.push({
                            event: 'order_view_finance_quote',
                            eventCategory: 'checkout',
                            eventAction: 'view finance quote',
                            eventLabel: `cars|${modelCode}|checkout|${clickText}|internal|bottom|#|${matchedOrder?.orderStatus}|${matchedOrder?.financeStatus}`,
                            actionType: 'view finance quote',
                            businessUnit: 'cars',
                            moduleName: 'checkout',
                            clickText: `${clickText}`,
                            clickType: 'internal',
                            destinationURL: '#',
                            modelSelected: `${modelCode}`,
                            inPageLocation: 'bottom',
                            orderStatus: `${matchedOrder?.orderStatus}`,
                            financeStatus: `${matchedOrder?.financeStatus}`,
                        });
                    });
                } else {
                    this.financeQuoteCta.classList.add('hide');
                }
            } else {
                this.onError();
            }
        }

        const { modelCode } = this.checkout.temp.ids;
        pushEmailAnalytics({
            formName: "order_form_submit", 
            model: modelCode, 
            sendName: true
        });
    }

    async getPaymentLink(order) {
        const result = await window.HONDA.MyAccount2.client.getPaymentLink(order);
        const { location } = window;
        const redirectPageLink = `${location.protocol}//${location.host}${this.confirmation}`;
        if (result?.paymentLink) {
            return `${result?.paymentLink}&successURL=${redirectPageLink}&cancelURL=${redirectPageLink}&pendingURL=${redirectPageLink}`;
        }
        return null;
    }

    async getDealerLink(order) {
        const url = this.dealerUrl;
        const dealer = order.dealer.dealerCode;
        const result = await window.HONDA.MyAccount2.client.getDealerDetails(url, dealer);
        return result?.dealer?.alias;
    }

    removeMtoceSavedConfiguration(order) {
        this.saved = this.localStorageParse('save-for-later');
        this.removed = this.localStorageParse('remove-for-later');

        const savedIndexValue = this.saved.findIndex((item) => item.mtoce === order?.summary?.ids?.mtoce);

        this.removed.push(this.saved[savedIndexValue]);
        this.saved.splice(savedIndexValue, 1);

        localStorage.setItem('remove-for-later', JSON.stringify(this.removed));
        localStorage.setItem('save-for-later', JSON.stringify(this.saved));
    }

    localStorageParse(key) {
        const json = localStorage.getItem(key);
        const items = json ? JSON.parse(json) : [];
        return items;
    }

    analyticsPush(type) {
        let clickText; let event; let eventAction; let destinationURL = '';
        const { modelCode } = this.checkout.temp.ids;
        const documentCountryCode = document.querySelector('html').getAttribute('country');
        const totalPrice = Number(this.order?.temp?.prices?.orderTotal);
        const { mtoce } = this.checkout.temp.ids;
        const { gradeCode } = this.checkout.temp.ids;
        const { colourCode } = this.checkout.temp.ids;

        if (type === 'confirm') {
            clickText = this.confirmCta?.textContent?.trim() || '';
            event = 'checkout_summary';
            eventAction = 'entry';
            destinationURL = '#';
        } else if (type === 'submit') {
            clickText = this.checkoutWrapper.querySelector('.form_submit button[type="submit"]')?.textContent?.trim() || '';
            event = 'checkout_completed';
            eventAction = 'complete';
            destinationURL = this.confirmation;
        }

        AnalyticsHelper.push({
            event: `${event}`,
            eventCategory: 'checkout',
            eventAction: `${eventAction}`,
            eventLabel: `cars|${modelCode}|checkout|${clickText}|internal|middle|${destinationURL}`,
            actionType: `${eventAction}`,
            businessUnit: 'cars',
            moduleName: 'checkout',
            clickText: `${clickText}`,
            clickType: 'internal',
            destinationURL: `${destinationURL}`,
            modelSelected: `${modelCode}`,
            inPageLocation: 'middle',
        });

        if (type === 'confirm') {
            AnalyticsHelper.push({ ecommerce: null }); // Clear the previous ecommerce object.
            AnalyticsHelper.push({
                event: 'add_shipping_info',
                actionType: 'ecommerce - add shipping info',
                businessUnit: 'cars',
                moduleName: 'ecommerce',
                clickText: 'continue to order summary',
                clickType: 'internal',
                destinationURL: '',
                modelSelected: modelCode,
                inPageLocation: '',
                countryCode: documentCountryCode,
                ecommerce: {
                    currency: window.HONDA?.currency?.ISO,
                    value: totalPrice,
                    items: [
                        {
                            item_id: mtoce,
                            item_name: modelCode,
                            discount: 0,
                            index: 0,
                            item_brand: 'HONDA',
                            gradeName: gradeCode,
                            colourName: colourCode,
                            dealerName: '',
                            price: totalPrice,
                            quantity: 1,
                        },
                    ],
                },
            });
        }
    }

    onError() {
        this.form?.showError();
        this.hideElements([this.loadingFinanceQuote]);
        this.showElements([this.formView]);
        this.retailerLink.setAttribute('href', '#');
        this.showElements([this.confirmCta]);
        this.hideElements([this.retailerLinkContainer]);
        this.confirmCta.setAttribute('href', '#');
    }

    onUpdate(field, valid) {
        this.showDealerLabels(field);
    }

    showDealerLabels(field) {
        const isDealerDetailsField = field?.el?.classList?.contains('form_field_dealer_details');
        if (isDealerDetailsField) {
            this.chosenDealerLabel?.classList?.remove('hide');
            this.chooseDealerLabel?.classList?.add('hide');
            this.changeDealerLabel?.classList?.remove('hide');
        }
    }

    getCheckout() {
        const json = sessionStorage.getItem('ma2-checkout');
        if (json) {
            this.checkout = this.parse(json);
        }
    }

    setBackToConfiguratorLink() {
        const configuratorUrl = this.checkout?.temp?.configuratorUrl;

        if (configuratorUrl) {
            this.backToConfiguratorLink.href = configuratorUrl;
            this.backToConfiguratorLink.classList.remove('hide');
        } else {
            this.backToConfiguratorLink.classList.add('hide');
        }
    }

    renderSummaryView(order) {
        if (order) {
            const data = {
                order,
                dateFormat,
                formatCurrency: this.formatCurrency.bind(this),
                stringReplace: StringUtils.replace,
                escapeHTML,
                dealerName: order.dealer?.dealerName,
                dealerAddress: `${order.dealer?.addressLine1}, ${order.dealer?.city}, ${order.dealer?.postCode}`,
                getPercentage: ({ number, numberOfDecimals }) => `${getNumberWithDecimals({ number, numberOfDecimals })}%`,
                promotions: addTooltips(order?.summary?.promotions),
                promotionsBannerContent: getBanner(order.summary?.promotions),
            };

            for (const [key, val] of Object.entries(this.summaryItems)) {
                this.summaryItems[key].innerHTML = this.summaryTemplates[key](data);
            }
            Tooltip.init();
            Tooltip.init('.discount-tooltip');
        }
    }

    parse(json) {
        try {
            return json ? JSON.parse(json) : null;
        } catch (err) {
            return null;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.checkout--container').forEach((el) => (el.classList.contains('load') ? new CarCheckout(el) : null));
});
